import { render, staticRenderFns } from "./phoneCall2.vue?vue&type=template&id=5785b0b8&scoped=true"
import script from "./phoneCall2.vue?vue&type=script&lang=js"
export * from "./phoneCall2.vue?vue&type=script&lang=js"
import style0 from "./phoneCall2.vue?vue&type=style&index=0&id=5785b0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5785b0b8",
  null
  
)

export default component.exports